import { Transition } from '@headlessui/react'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as Yup from "yup";
import React, { useState } from 'react'

export default function ApplicationProgressOffCanvas({ openOffCanvas, setOpenOffCanvas }) {

    const [initialValues, setInitialValues] = useState({
        overallProgress: "",
        averageScore: "",
        Attendent: "",
    });

    const validationSchema = Yup.object({
        overallProgress: Yup.string().required("Add Overall Progress"),
        averageScore: Yup.string().required("Add Average Score"),
        Attendent: Yup.string().required("Add Attendent"),
    });

    const handleSubmit = async (values, resetForm) => {
        try {

        } catch (e) {
        }
    };
    return (
        <Transition show={openOffCanvas}>
            <div className="fixed inset-0 z-50 flex justify-end">
                {/* Overlay */}
                <div
                    className="fixed inset-0 bg-black bg-opacity-50"
                    onClick={() => setOpenOffCanvas(false)}
                ></div>

                {/* Offcanvas Panel */}
                <div className="relative bg-white w-full max-w-[650px] h-full shadow-lg p-6">
                    {/* Header */}
                    <div className="flex justify-between items-center  pb-3">
                        <h2 className="text-[22px] font-bold text-primary-900">
                            Application Progress
                        </h2>
                        <button
                            className="text-gray-500 hover:text-gray-800"
                            onClick={() => setOpenOffCanvas(false)}
                        >
                            ✕
                        </button>
                    </div>

                    {/* Body */}
                    <div className='mt-3'>
                        <Formik
                            initialValues={initialValues}
                            enableReinitialize={true}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                        >
                            {({ setFieldValue }) => (
                                <Form >
                                    <label className="text-md text-[#717576] font-normal">
                                        Overall Progress
                                    </label>
                                    <Field
                                        name="overallProgress"
                                        type="text"
                                        placeholder="Enter overall progress"
                                        className="w-full border p-3 my-[9px] h-[60px] rounded-[10px] remove_numberarrows"
                                        maxLength="3"
                                        onInput={(e) => {
                                            e.target.value = e.target.value.replace(/[^0-9]/g, ''); // only allow digits
                                        }}
                                    />
                                    <ErrorMessage
                                        name="overallProgress"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                    <label className="text-md text-[#717576] font-normal">
                                        Average Score
                                    </label>
                                    <Field
                                        name="averageScore"
                                        type="text"
                                        placeholder="Enter average score"
                                        className="w-full border p-3 my-[9px] h-[60px] rounded-[10px] remove_numberarrows"
                                        onInput={(e) => {
                                            e.target.value = e.target.value.replace(/[^0-9]/g, ''); // only allow digits
                                        }}
                                    />
                                    <ErrorMessage
                                        name="averageScore"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                    <label className="text-md text-[#717576] font-normal">
                                        Attendents
                                    </label>
                                    <Field
                                        name="Attendent"
                                        type="text"
                                        placeholder="Enter attendents and participant"
                                        className="w-full border p-3 my-[9px] h-[60px] rounded-[10px] remove_numberarrows"
                                        onInput={(e) => {
                                            e.target.value = e.target.value.replace(/[^0-9]/g, ''); // only allow digits
                                        }}
                                    />
                                    <ErrorMessage
                                        name="Attendent"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                    <div className="flex justify-between gap-3 pt-4">
                                        <button
                                            type="button"
                                            onClick={() => setOpenOffCanvas(false)}
                                            className="px-4 py-4 w-full rounded-[10px] border border-brandBlue text-brandBlue bg-transparent hover:bg-brandBlue hover:text-white transition"
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            type="submit"
                                            className="px-4 py-4 w-full rounded-[10px] bg-brandBlue text-white hover:bg-primary-700 transition btn-primary"
                                        >
                                            Save & Add
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>

                    </div>
                </div>
            </div>
        </Transition>
    )
}
